import { render, staticRenderFns } from "./lrInputColor.vue?vue&type=template&id=831a2b7a"
import script from "./lrInputColor.vue?vue&type=script&lang=js"
export * from "./lrInputColor.vue?vue&type=script&lang=js"
import style0 from "./lrInputColor.vue?vue&type=style&index=0&id=831a2b7a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports